/**
 * LoomEmbed Component
 * 
 * Renders Loom videos using a standard responsive iframe embed.
 * Uses 16:9 aspect ratio container - the industry standard for video embeds.
 */

import React from 'react';
import { Play, ExternalLink } from 'lucide-react';

function LoomEmbed({ videoId, url }) {
  // Extract video ID from URL if provided
  const extractedVideoId = videoId || (url && url.match(/loom\.com\/share\/([a-zA-Z0-9]+)/)?.[1]);
  
  if (!extractedVideoId) {
    return null;
  }

  const loomUrl = `https://www.loom.com/share/${extractedVideoId}`;
  const embedUrl = `https://www.loom.com/embed/${extractedVideoId}`;

  return (
    <div>
      <div
        className="rounded-lg overflow-hidden"
        style={{
          position: 'relative',
          width: '100%',
          paddingBottom: '56.25%', // 16:9 aspect ratio
          backgroundColor: '#000'
        }}
      >
        <iframe
          src={embedUrl}
          frameBorder="0"
          allowFullScreen
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; fullscreen; gyroscope; picture-in-picture; web-share"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 'none'
          }}
          title="Loom video"
          loading="lazy"
        />
      </div>
      <div className="mt-1.5 text-right">
        <a
          href={loomUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-[11px] text-slate-400 dark:text-slate-500 hover:text-indigo-500 dark:hover:text-indigo-400"
        >
          <ExternalLink className="w-3 h-3" />
          Trouble playing? Open in Loom
        </a>
      </div>
    </div>
  );
}

export default LoomEmbed;
